import angular, { IOnInit } from "angular";
import { FormSubmitArgs, FormViewConfig } from "../../forms/formView";
import { IQuery } from "../../server/query";
import { GridConfiguration } from "../../views/recordGridView";
import { LookupModalOptions } from "./service";
import { UserProfile } from "../../../application/UserProfile";

export class LookupModalController implements IOnInit {
  static $inject = ["userProfile"];
  Active: boolean = true;
  readonly defaultQuery: IQuery = {
    Disabled: false,
  };

  /* bindings */
  readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  readonly resolve!: {
    config: LookupModalOptions;
    formViewConfig: FormViewConfig;
    displayName: string;
    model: any;
    gridConfiguration: GridConfiguration;
    onSubmit: [
      ...string[],
      (args: FormSubmitArgs) => [...string[], Promise<any>]
    ];
    onCancel: [
      ...string[],
      (args: FormSubmitArgs) => [...string[], Promise<any>]
    ];
  };
  /* bindings */

  constructor(private readonly userProfile: UserProfile) {
    this.setModalWidth("950px");
  }
  $onInit() {}
  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
  activeRecordChanged(Active: boolean) {
    this.Active = Active;
    if (Active) {
      this.defaultQuery.Disabled = false;
    } else {
      this.defaultQuery.Disabled = undefined;
    }
  }
}
